import employeePerformanceReportsReducer from './employeePerformance/reducer'

export const performanceReportsReducer = {
  employeePerformanceReportsReducer,
}
